import { Link } from "@/components/marketing/elements/link"
import { ArrowNarrowRightIcon } from "@/components/marketing/icons/arrow-narrow-right-icon"
import { ResponsiveAppScreenshot } from "@/components/marketing/ResponsiveAppScreenshot"
import {
  Feature,
  FeaturesTwoColumnWithDemos,
} from "@/components/marketing/sections/features-two-column-with-demos"
import { OWNERSHIP_FEATURES } from "@/content/marketing/site-content"
import { primaryCtaHref, primaryCtaLabel } from "@/lib/launch-config"

export function MarketingOwnershipSection() {
  return (
    <FeaturesTwoColumnWithDemos
      id="own-your-data"
      eyebrow="How it's organized"
      headline="Structured content, not a ticket graveyard"
      subheadline={
        <p>
          Scenarios aren&apos;t disposable tickets or prose scattered across docs and chat. Each one is a
          structured fact with a title, evidence, and relationships, stored in your workspace and readable by
          your whole team, with a full history of every change.
        </p>
      }
      features={
        <>
          {OWNERSHIP_FEATURES.map((item) => (
            <Feature
              key={item.id}
              demo={<ResponsiveAppScreenshot shot={item.shot} wallpaper={item.wallpaper} placement={item.placement} />}
              headline={item.headline}
              subheadline={<p>{item.subheadline}</p>}
              cta={
                <Link href={primaryCtaHref()}>
                  {primaryCtaLabel()} <ArrowNarrowRightIcon />
                </Link>
              }
            />
          ))}
        </>
      }
    />
  )
}
